
import BackButtonOutlined from "../common/back-button-outlined.vue";
export default {
  components: { BackButtonOutlined },
  props: {
    status: {
      type: String,
      dafault: ""
    },
    orderId: {
      type: String,
      dafault: ""
    }
  }
};
